// extracted by mini-css-extract-plugin
module.exports = {"sliderHolder":"LivestreamScreenshareVolume_sliderHolder__24NKP"};